export var clamp = function (x, min, max) { return Math.min(Math.max(x, min), max); };
export var sleep = function (ms) { return new Promise(function (r) { return setTimeout(r, ms); }); };
